import React, { createElement, useState, Fragment } from 'react';
import styled from 'styled-components';
import { Flex, Box } from 'reflexbox';
import Toggle from 'react-toggle';
import 'react-toggle/style.css';
import { useCookies } from 'react-cookie';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
}

var StyledFooter = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 100px;\n  padding: 25px;\n  font-family: inherit;\n  color: ", ";\n  background-color: ", ";\n  p {\n    margin: 0 0 12px 0;\n    font-size: 0.9em;\n  }\n  div,\n  a {\n    margin: 0 0 10px 0;\n    color: inherit;\n  }\n  a {\n    text-decoration: underline;\n    font-size: 0.9em;\n  }\n  h2 {\n    font-weight: 700;\n    font-size: 1em;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 100px;\n  padding: 25px;\n  font-family: inherit;\n  color: ", ";\n  background-color: ", ";\n  p {\n    margin: 0 0 12px 0;\n    font-size: 0.9em;\n  }\n  div,\n  a {\n    margin: 0 0 10px 0;\n    color: inherit;\n  }\n  a {\n    text-decoration: underline;\n    font-size: 0.9em;\n  }\n  h2 {\n    font-weight: 700;\n    font-size: 1em;\n  }\n"])), function (props) {
  return props.color || 'inherit';
}, function (props) {
  return props.backgroundColor || 'inherit';
});
var templateObject_1;

var Footer = function Footer(_a) {
  var logo = _a.logo,
      logoWidth = _a.logoWidth,
      company = _a.company,
      vat = _a.vat,
      phone = _a.phone,
      contactTitle = _a.contactTitle,
      email = _a.email,
      address = _a.address,
      socialMediaTitle = _a.socialMediaTitle,
      facebook = _a.facebook,
      facebookHandle = _a.facebookHandle,
      facebookLogo = _a.facebookLogo,
      instagram = _a.instagram,
      instagramHandle = _a.instagramHandle,
      instagramLogo = _a.instagramLogo,
      linkedin = _a.linkedin,
      linkedinHandle = _a.linkedinHandle,
      linkedinLogo = _a.linkedinLogo,
      twitter = _a.twitter,
      twitterHandle = _a.twitterHandle,
      twitterLogo = _a.twitterLogo,
      youtube = _a.youtube,
      youtubeHandle = _a.youtubeHandle,
      youtubeLogo = _a.youtubeLogo,
      color = _a.color,
      backgroundColor = _a.backgroundColor,
      children = _a.children;
  return createElement(StyledFooter, {
    color: color,
    backgroundColor: backgroundColor
  }, createElement(Flex, {
    justifyContent: "space-between",
    flexWrap: "wrap"
  }, createElement(BrandWrapper, {
    p: 3
  }, logo && createElement(Logo, {
    src: logo,
    logoWidth: logoWidth,
    alt: "logo"
  }), company && createElement("p", null, company), vat && createElement("p", null, vat)), createElement(ContactWrapper, {
    p: 3
  }, contactTitle ? createElement("h2", null, contactTitle) : createElement("h2", null, "Contact"), phone && createElement("p", null, phone), email && createElement("p", null, email), address && createElement("p", null, address)), createElement(SocialMediaWrapper, {
    p: 3
  }, socialMediaTitle ? createElement("h2", null, socialMediaTitle) : createElement("h2", null, "Social media"), facebook && createElement(SocialMedium, null, facebookLogo && createElement(SocialMediaLogo, {
    src: facebookLogo,
    alt: "Facebook"
  }), createElement("a", {
    href: facebook,
    rel: "noreferrer noopener",
    target: "_blank"
  }, facebookHandle ? facebookHandle : 'Facebook')), instagram && createElement(SocialMedium, null, instagramLogo && createElement(SocialMediaLogo, {
    src: instagramLogo,
    alt: "Instagram"
  }), createElement("a", {
    href: instagram,
    rel: "noreferrer noopener",
    target: "_blank"
  }, instagramHandle ? instagramHandle : 'Instagram')), linkedin && createElement(SocialMedium, null, linkedinLogo && createElement(SocialMediaLogo, {
    src: linkedinLogo,
    alt: "LinkedIn"
  }), createElement("a", {
    href: linkedin,
    rel: "noreferrer noopener",
    target: "_blank"
  }, linkedinHandle ? linkedinHandle : 'LinkedIn')), twitter && createElement(SocialMedium, null, twitterLogo && createElement(SocialMediaLogo, {
    src: twitterLogo,
    alt: "Twitter"
  }), createElement("a", {
    href: twitter,
    rel: "noreferrer noopener",
    target: "_blank"
  }, twitterHandle ? twitterHandle : 'Twitter')), youtube && createElement(SocialMedium, null, youtubeLogo && createElement(SocialMediaLogo, {
    src: youtubeLogo,
    alt: "YouTube"
  }), createElement("a", {
    href: linkedin,
    rel: "noreferrer noopener",
    target: "_blank"
  }, youtubeHandle ? youtubeHandle : 'YouTube'))), createElement(SiteMap, {
    p: 3
  }, createElement(Flex, {
    flexDirection: "column"
  }, children && createElement("h2", null, "Site map"), children))), createElement(Upshift, null, createElement(UpshiftContent, null, "Copyright \xA9 ", company, " - website door", ' ', createElement("a", {
    href: "https://upshift.be",
    rel: "noreferrer noopener",
    target: "_blank"
  }, "upshift"))));
};

var SocialMedium = styled.div(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  margin: 10px 0;\n"], ["\n  margin: 10px 0;\n"])));
var SocialMediaLogo = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 25px;\n  vertical-align: middle;\n  margin-right: 5px;\n"], ["\n  width: 25px;\n  vertical-align: middle;\n  margin-right: 5px;\n"])));
var Logo = styled.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: ", ";\n  height: auto;\n  margin: 12px 0;\n"], ["\n  width: ", ";\n  height: auto;\n  margin: 12px 0;\n"])), function (props) {
  return props.logoWidth || '100px';
});
var BrandWrapper = styled(Box)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var Upshift = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"])));
var UpshiftContent = styled.p(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var ContactWrapper = styled(Box)(templateObject_7 || (templateObject_7 = __makeTemplateObject([""], [""])));
var SocialMediaWrapper = styled(Box)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var SiteMap = styled(Box)(templateObject_9 || (templateObject_9 = __makeTemplateObject([""], [""])));
var templateObject_1$1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
var StyledCookieConsent = styled.div(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  align-items: center;\n  background-color: ", ";\n  border-radius: 15px;\n  bottom: 15px;\n  box-shadow: 0 0 10px 10px #6d6d6d24;\n  flex-direction: row;\n  font-family: 'Poppins', sans-serif;\n  font-size: 12px !important;\n  left: 2%;\n  max-width: 96%;\n  min-width: 320px;\n  padding: 8px;\n  position: fixed;\n  width: 1000px;\n  z-index: 999;\n\n  #mobileOnly {\n    @media only screen and (min-width: 769px) {\n      visibility: hidden;\n      height: 0;\n      width: 0;\n    }\n  }\n\n  #desktopOnly {\n    @media only screen and (max-width: 768px) {\n      visibility: hidden;\n      height: 0;\n      width: 0;\n    }\n  }\n\n  img#logoImg {\n    max-width: 100%;\n    max-height: 50px;\n  }\n\n  p.summaryText {\n    color: #222222;\n    font-size: 12px;\n    line-height: 16px;\n    background: rgba(0, 0, 0, 0);\n    margin: 3px 0;\n  }\n\n  a.cookiePolicyLink {\n    color: #222222;\n    cursor: pointer;\n    display: block;\n    font-size: 12px;\n    font-weight: bold;\n    text-decoration: underline;\n  }\n\n  button.moreInfo {\n    background: none;\n    border: 1px solid lightgrey;\n    cursor: pointer;\n    border-radius: 15px;\n    padding: 5px 10px;\n    color: #616161;\n    margin-bottom: 3px;\n    font-family: 'Poppins', sans-serif;\n    font-size: 12px;\n  }\n\n  button.callToAction {\n    background-color: #061e5b;\n    border-radius: 15px;\n    border: none;\n    color: white;\n    cursor: pointer;\n    margin-left: 10px;\n    font-size: 12px;\n    padding: 5px 10px;\n    font-family: 'Poppins', sans-serif;\n    transition: all 0.2s ease-in-out;\n\n    &::not(:last-child) {\n      margin-right: 15px;\n    }\n\n    &.neutral {\n      background-color: rgba(0, 0, 0, 0);\n      color: #061e5b;\n      &:hover {\n        background-color: rgba(0, 0, 0, 0.1);\n      }\n    }\n\n    &.show {\n      background-color: rgba(0, 0, 0, 0);\n      color: #061e5b;\n      padding: 0px;\n      margin-bottom: 10px;\n\n      &:hover {\n        text-decoration: underline;\n        cursor: pointer;\n      }\n    }\n  }\n\n  span.category {\n    color: #222222;\n    line-height: 1.5;\n    font-size: 12px;\n    margin: 0 15px 0 5px;\n    font-family: 'Poppins', sans-serif;\n  }\n\n  .react-toggle-thumb {\n    height: 18px;\n    width: 18px;\n  }\n\n  .react-toggle-track {\n    height: 20px;\n    width: 44px;\n  }\n"], ["\n  align-items: center;\n  background-color: ", ";\n  border-radius: 15px;\n  bottom: 15px;\n  box-shadow: 0 0 10px 10px #6d6d6d24;\n  flex-direction: row;\n  font-family: 'Poppins', sans-serif;\n  font-size: 12px !important;\n  left: 2%;\n  max-width: 96%;\n  min-width: 320px;\n  padding: 8px;\n  position: fixed;\n  width: 1000px;\n  z-index: 999;\n\n  #mobileOnly {\n    @media only screen and (min-width: 769px) {\n      visibility: hidden;\n      height: 0;\n      width: 0;\n    }\n  }\n\n  #desktopOnly {\n    @media only screen and (max-width: 768px) {\n      visibility: hidden;\n      height: 0;\n      width: 0;\n    }\n  }\n\n  img#logoImg {\n    max-width: 100%;\n    max-height: 50px;\n  }\n\n  p.summaryText {\n    color: #222222;\n    font-size: 12px;\n    line-height: 16px;\n    background: rgba(0, 0, 0, 0);\n    margin: 3px 0;\n  }\n\n  a.cookiePolicyLink {\n    color: #222222;\n    cursor: pointer;\n    display: block;\n    font-size: 12px;\n    font-weight: bold;\n    text-decoration: underline;\n  }\n\n  button.moreInfo {\n    background: none;\n    border: 1px solid lightgrey;\n    cursor: pointer;\n    border-radius: 15px;\n    padding: 5px 10px;\n    color: #616161;\n    margin-bottom: 3px;\n    font-family: 'Poppins', sans-serif;\n    font-size: 12px;\n  }\n\n  button.callToAction {\n    background-color: #061e5b;\n    border-radius: 15px;\n    border: none;\n    color: white;\n    cursor: pointer;\n    margin-left: 10px;\n    font-size: 12px;\n    padding: 5px 10px;\n    font-family: 'Poppins', sans-serif;\n    transition: all 0.2s ease-in-out;\n\n    &::not(:last-child) {\n      margin-right: 15px;\n    }\n\n    &.neutral {\n      background-color: rgba(0, 0, 0, 0);\n      color: #061e5b;\n      &:hover {\n        background-color: rgba(0, 0, 0, 0.1);\n      }\n    }\n\n    &.show {\n      background-color: rgba(0, 0, 0, 0);\n      color: #061e5b;\n      padding: 0px;\n      margin-bottom: 10px;\n\n      &:hover {\n        text-decoration: underline;\n        cursor: pointer;\n      }\n    }\n  }\n\n  span.category {\n    color: #222222;\n    line-height: 1.5;\n    font-size: 12px;\n    margin: 0 15px 0 5px;\n    font-family: 'Poppins', sans-serif;\n  }\n\n  .react-toggle-thumb {\n    height: 18px;\n    width: 18px;\n  }\n\n  .react-toggle-track {\n    height: 20px;\n    width: 44px;\n  }\n"])), function (props) {
  return props.backgroundColor ? props.backgroundColor : 'white';
});
var Title = styled.h4(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  border: none;\n  font-size: 16px;\n  margin: 0;\n"], ["\n  border: none;\n  font-size: 16px;\n  margin: 0;\n"])));
var templateObject_1$2, templateObject_2$1;

var CookieConsent = function CookieConsent(_a) {
  var allowAllText = _a.allowAllText,
      allowSelectionText = _a.allowSelectionText,
      linkText = _a.linkText,
      linkToPolicy = _a.linkToPolicy,
      logo = _a.logo,
      marketing = _a.marketing,
      marketingText = _a.marketingText,
      necessaryText = _a.necessaryText,
      noTitle = _a.noTitle,
      preferences = _a.preferences,
      preferencesText = _a.preferencesText,
      showExplanationText = _a.showExplanationText,
      socials = _a.socials,
      socialsText = _a.socialsText,
      statistics = _a.statistics,
      statisticsText = _a.statisticsText,
      summary = _a.summary,
      title = _a.title;

  var _b = useState(false),
      showExplanation = _b[0],
      setShowExplanation = _b[1];

  var _c = useCookies(['']),
      cookies = _c[0],
      setCookies = _c[1];

  var _d = useState(false),
      reacted = _d[0],
      setReacted = _d[1];

  var _e = useState('off'),
      togglePreferences = _e[0],
      setTogglePreferences = _e[1];

  var _f = useState('off'),
      toggleStatistics = _f[0],
      setToggleStatistics = _f[1];

  var _g = useState('off'),
      toggleMarketing = _g[0],
      setToggleMarketing = _g[1];

  var _h = useState('off'),
      toggleSocials = _h[0],
      setToggleSocials = _h[1];

  var AllowSelection = function AllowSelection() {
    setCookies('cookiesConsentReacted', 'true');
    togglePreferences === 'on' && setCookies('cookiesConsentPreferences', 'allow');
    toggleStatistics === 'on' && setCookies('cookiesConsentStatistics', 'allow');
    toggleMarketing === 'on' && setCookies('cookiesConsentMarketing', 'allow');
    toggleSocials === 'on' && setCookies('cookiesConsentSocials', 'allow');
    setReacted(true);
  };

  var AllowAll = function AllowAll() {
    setCookies('cookiesConsentReacted', 'true');
    setCookies('cookiesConsentPreferences', 'allow');
    setCookies('cookiesConsentStatistics', 'allow');
    setCookies('cookiesConsentMarketing', 'allow');
    setCookies('cookiesConsentSocials', 'allow');
    setReacted(true);
  };

  return React.createElement("div", null, !(cookies.cookiesConsentReacted || reacted) && React.createElement(StyledCookieConsent, null, !noTitle && React.createElement(Flex, {
    width: "100%"
  }, React.createElement(Box, {
    alignSelf: "center",
    width: 3 / 4,
    mr: 3
  }, React.createElement(Title, null, title)), React.createElement(Box, {
    width: 1 / 4
  }, React.createElement("img", {
    id: "logoImg",
    src: logo,
    alt: "logo"
  }))), React.createElement("div", {
    id: "mobileOnly"
  }, showExplanation ? React.createElement(Box, null, React.createElement("p", {
    className: "summaryText"
  }, summary), React.createElement("a", {
    className: "cookiePolicyLink",
    style: {
      display: 'block'
    },
    target: "_blank",
    rel: "noreferrer noopener",
    href: linkToPolicy
  }, linkText)) : React.createElement("button", {
    className: "moreInfo show",
    onClick: function onClick() {
      return setShowExplanation(!showExplanation);
    }
  }, "" + showExplanationText)), React.createElement("div", {
    id: "desktopOnly"
  }, React.createElement(Box, null, React.createElement("p", {
    className: "summaryText"
  }, summary), React.createElement("a", {
    className: "cookiePolicyLink",
    href: linkToPolicy,
    target: "_blank",
    rel: "noreferrer noopener"
  }, linkText))), React.createElement(Flex, {
    flexWrap: "wrap"
  }, React.createElement(Flex, {
    flexWrap: "wrap"
  }, React.createElement(Flex, {
    alignItems: "center",
    my: 1
  }, React.createElement(Toggle, {
    defaultChecked: true,
    disabled: true
  }), React.createElement("span", {
    className: "category"
  }, necessaryText)), preferences && React.createElement(Flex, {
    alignItems: "center",
    my: 1
  }, React.createElement(Toggle, {
    value: togglePreferences,
    onChange: function onChange() {
      togglePreferences === 'off' ? setTogglePreferences('on') : setTogglePreferences('off');
    }
  }), React.createElement("span", {
    className: "category"
  }, preferencesText)), statistics && React.createElement(Flex, {
    alignItems: "center",
    my: 1
  }, React.createElement(Toggle, {
    value: toggleStatistics,
    onChange: function onChange() {
      toggleStatistics === 'off' ? setToggleStatistics('on') : setToggleStatistics('off');
    }
  }), React.createElement("span", {
    className: "category"
  }, statisticsText)), marketing && React.createElement(Flex, {
    alignItems: "center",
    my: 1
  }, React.createElement(Toggle, {
    value: toggleMarketing,
    onChange: function onChange() {
      toggleMarketing === 'off' ? setToggleMarketing('on') : setToggleMarketing('off');
    }
  }), React.createElement("span", {
    className: "category"
  }, marketingText)), socials && React.createElement(Flex, {
    alignItems: "center",
    my: 1
  }, React.createElement(Toggle, {
    value: toggleSocials,
    onChange: function onChange() {
      toggleSocials === 'off' ? setToggleSocials('on') : setToggleSocials('off');
    }
  }), React.createElement("span", {
    className: "category"
  }, socialsText))), React.createElement(Flex, {
    flexGrow: 1,
    justifyContent: "flex-end"
  }, React.createElement(Flex, {
    minWidth: "280px",
    justifyContent: "flex-end",
    mt: 1
  }, React.createElement(Box, null, React.createElement("button", {
    className: "callToAction neutral",
    onClick: function onClick() {
      return AllowSelection();
    }
  }, allowSelectionText)), React.createElement(Box, null, React.createElement("button", {
    className: "callToAction",
    onClick: function onClick() {
      return AllowAll();
    }
  }, allowAllText)))))));
};

var StyledBurger = styled.button(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  z-index: 11;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 5px;\n  background-color: lightgrey;\n  padding: 10px 5px;\n  cursor: pointer;\n  &:focus {\n    outline: none;\n  }\n  div {\n    width: 30px;\n    height: 4px;\n    background: black;\n    border-radius: 10px;\n    transition: all 0.3s linear;\n    position: relative;\n\n    :first-child {\n      transform: ", ";\n      width: ", ";\n      transform-origin: top left;\n    }\n    :nth-child(2) {\n      opacity: ", ";\n      transform: ", ";\n    }\n    :nth-child(3) {\n      transform: ", ";\n      width: ", ";\n      transform-origin: bottom left;\n    }\n  }\n"], ["\n  z-index: 11;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 5px;\n  background-color: lightgrey;\n  padding: 10px 5px;\n  cursor: pointer;\n  &:focus {\n    outline: none;\n  }\n  div {\n    width: 30px;\n    height: 4px;\n    background: black;\n    border-radius: 10px;\n    transition: all 0.3s linear;\n    position: relative;\n\n    :first-child {\n      transform: ", ";\n      width: ", ";\n      transform-origin: top left;\n    }\n    :nth-child(2) {\n      opacity: ", ";\n      transform: ", ";\n    }\n    :nth-child(3) {\n      transform: ", ";\n      width: ", ";\n      transform-origin: bottom left;\n    }\n  }\n"])), function (props) {
  return props.isOpen ? 'rotate(34deg) translateY(-2px)' : 'rotate(0) translateY(0)';
}, function (props) {
  return props.isOpen ? '36px' : '30px';
}, function (props) {
  return props.isOpen ? '0' : '1';
}, function (props) {
  return props.isOpen ? 'translateX(20px)' : 'translateX(0)';
}, function (props) {
  return props.isOpen ? 'rotate(-34deg) translateY(2px)' : 'rotate(0) translateY(0)';
}, function (props) {
  return props.isOpen ? '36px' : '30px';
});
var templateObject_1$3;

var Burger = function Burger(_a) {
  var isOpen = _a.isOpen,
      setIsOpen = _a.setIsOpen;
  return createElement(StyledBurger, {
    isOpen: isOpen,
    onClick: setIsOpen
  }, createElement("div", null), createElement("div", null), createElement("div", null));
};

var StyledMobileMenu = styled.nav(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  background: rgba(0, 0, 0, 0.9);\n  height: 85%;\n  text-align: center;\n  padding: 1rem;\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  border-top-right-radius: 25px;\n  transition: transform 0.3s ease-in-out;\n  transform: ", ";\n  > div {\n    margin-top: 100px;\n  }\n  a {\n    @media (min-width: 640px) {\n      font-size: 2rem;\n    }\n    font-size: 1.5rem;\n    text-transform: uppercase;\n    font-weight: bold;\n    margin-bottom: 10px;\n    display: inline-block;\n    letter-spacing: 0.5rem;\n    color: white;\n    text-decoration: none;\n    font-family: 'Amatic SC', sans-serif;\n    transition: color 0.3s linear;\n    &:after {\n      content: '';\n      display: block;\n      height: 3px;\n      width: 0;\n      background: transparent;\n      transition: width 0.3s ease, background-color 0.3s ease;\n      margin: auto;\n    }\n    /* Change the width and background on hover, aka sliding out */\n    &:hover:after {\n      width: 100%;\n      background: white;\n    }\n    @media (max-width: ", ") {\n      font-size: 1.5rem;\n      text-align: center;\n    }\n  }\n"], ["\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  background: rgba(0, 0, 0, 0.9);\n  height: 85%;\n  text-align: center;\n  padding: 1rem;\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  border-top-right-radius: 25px;\n  transition: transform 0.3s ease-in-out;\n  transform: ", ";\n  > div {\n    margin-top: 100px;\n  }\n  a {\n    @media (min-width: 640px) {\n      font-size: 2rem;\n    }\n    font-size: 1.5rem;\n    text-transform: uppercase;\n    font-weight: bold;\n    margin-bottom: 10px;\n    display: inline-block;\n    letter-spacing: 0.5rem;\n    color: white;\n    text-decoration: none;\n    font-family: 'Amatic SC', sans-serif;\n    transition: color 0.3s linear;\n    &:after {\n      content: '';\n      display: block;\n      height: 3px;\n      width: 0;\n      background: transparent;\n      transition: width 0.3s ease, background-color 0.3s ease;\n      margin: auto;\n    }\n    /* Change the width and background on hover, aka sliding out */\n    &:hover:after {\n      width: 100%;\n      background: white;\n    }\n    @media (max-width: ", ") {\n      font-size: 1.5rem;\n      text-align: center;\n    }\n  }\n"])), function (props) {
  return props.isOpen ? 'translateX(0)' : 'translateX(-120%)';
}, function (_a) {
  var theme = _a.theme;
  return theme.mobile;
});
var templateObject_1$4;
var StyledMobileMenuButton = styled.button(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  background-color: grey;\n  color: white;\n  font-family: inherit;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  padding: 5px 10px;\n"], ["\n  background-color: grey;\n  color: white;\n  font-family: inherit;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  padding: 5px 10px;\n"])));
var templateObject_1$5;

var MobileMenuButton = function MobileMenuButton(_a) {
  var buttonText = _a.buttonText,
      action = _a.action;
  return createElement(StyledMobileMenuButton, {
    onClick: action
  }, buttonText);
};

var MobileMenu = function MobileMenu(_a) {
  var isOpen = _a.isOpen,
      setIsOpen = _a.setIsOpen,
      children = _a.children,
      type = _a.type,
      buttonText = _a.buttonText,
      action = _a.action;
  return createElement(StyledMobileMenu, {
    isOpen: isOpen,
    type: type
  }, createElement("div", null, children === null || children === void 0 ? void 0 : children.map(function (child, index) {
    return createElement("div", {
      key: index,
      onClick: setIsOpen
    }, child);
  })), buttonText && action && createElement(MobileMenuButton, {
    buttonText: buttonText,
    action: action
  }));
};

var StyledNavBar = styled.nav(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  color: ", ";\n  justify-content: space-between;\n  height: 100%;\n  display: flex;\n  position: fixed;\n  transition: all 0.3s ease-in-out;\n  overflow: hidden;\n  width: ", ";\n  box-shadow: ", ";\n  text-align: left;\n  opacity: ", ";\n  visibility: ", ";\n  background-color: ", ";\n  flex-direction: column;\n  align-items: left;\n  button {\n    margin-right: 15px;\n  }\n"], ["\n  color: ", ";\n  justify-content: space-between;\n  height: 100%;\n  display: flex;\n  position: fixed;\n  transition: all 0.3s ease-in-out;\n  overflow: hidden;\n  width: ", ";\n  box-shadow: ", ";\n  text-align: left;\n  opacity: ", ";\n  visibility: ", ";\n  background-color: ", ";\n  flex-direction: column;\n  align-items: left;\n  button {\n    margin-right: 15px;\n  }\n"])), function (props) {
  return props.color || 'inherit';
}, function (props) {
  return props.width || 'unset';
}, function (props) {
  return props.boxShadow || 'none';
}, function (props) {
  return props.isOpen ? '100%' : '0';
}, function (props) {
  return props.isOpen ? 'visible' : 'hidden';
}, function (props) {
  return props.backgroundColor || 'white';
});
var templateObject_1$6;

var SideNavBar = function SideNavBar(_a) {
  var children = _a.children,
      color = _a.color,
      backgroundColor = _a.backgroundColor,
      position = _a.position,
      boxShadow = _a.boxShadow,
      width = _a.width,
      mobileWidth = _a.mobileWidth,
      breakPoint = _a.breakPoint;

  var _b = useState(false),
      isOpen = _b[0],
      setIsOpen = _b[1];

  var handleSetOpen = function handleSetOpen() {
    return setIsOpen(!isOpen);
  };

  return createElement(Fragment, null, createElement(BurgerHelper, {
    breakPoint: breakPoint
  }, createElement(Burger, {
    isOpen: isOpen,
    setIsOpen: handleSetOpen
  })), createElement(StyledNavBar, {
    backgroundColor: backgroundColor,
    position: position,
    color: color,
    isOpen: isOpen,
    boxShadow: boxShadow,
    width: mobileWidth
  }, children), createElement(StyledNavBarHelper, {
    breakPoint: breakPoint
  }, createElement(StyledNavBar, {
    backgroundColor: backgroundColor,
    position: position,
    color: color,
    isOpen: true,
    boxShadow: boxShadow,
    width: width
  }, children)));
};

var BurgerHelper = styled.div(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  @media (min-width: ", ") {\n    display: none;\n  }\n  position: fixed;\n  top: 5px;\n  right: 5px;\n  z-index: 11;\n"], ["\n  @media (min-width: ", ") {\n    display: none;\n  }\n  position: fixed;\n  top: 5px;\n  right: 5px;\n  z-index: 11;\n"])), function (props) {
  return props.breakPoint || '768px';
});
var StyledNavBarHelper = styled.div(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  @media (max-width: ", ") {\n    display: none;\n  }\n"], ["\n  @media (max-width: ", ") {\n    display: none;\n  }\n"])), function (props) {
  return props.breakPoint || '767px';
});
var templateObject_1$7, templateObject_2$2;
var StyledNavButton = styled.button(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  background-color: grey;\n  color: ", ";\n  font-family: inherit;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  background-color: ", ";\n  font-size: 0.8em;\n  padding: 5px 10px;\n  @media (max-width: 768px) {\n    display: none;\n  }\n"], ["\n  background-color: grey;\n  color: ", ";\n  font-family: inherit;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  background-color: ", ";\n  font-size: 0.8em;\n  padding: 5px 10px;\n  @media (max-width: 768px) {\n    display: none;\n  }\n"])), function (props) {
  return props.color || 'inherit';
}, function (props) {
  return props.buttonBackgroundColor || 'white';
});
var templateObject_1$8;

var NavButton = function NavButton(_a) {
  var buttonText = _a.buttonText,
      action = _a.action,
      buttonColor = _a.buttonColor,
      buttonBackgroundColor = _a.buttonBackgroundColor;
  return createElement(StyledNavButton, {
    onClick: action,
    buttonColor: buttonColor,
    buttonBackgroundColor: buttonBackgroundColor
  }, buttonText);
};

var StyledNavLinks = styled.div(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  a {\n    padding-left: 15px;\n    color: ", ";\n    text-decoration: none;\n    &:after {\n      content: '';\n      display: block;\n      height: 3px;\n      width: 0;\n      background: transparent;\n      transition: width 0.3s ease, background-color 0.3s ease;\n      margin: auto;\n    }\n    /* Change the width and background on hover, aka sliding out */\n    &:hover:after {\n      width: 100%;\n      background: black;\n    }\n  }\n  @media (max-width: 768px) {\n    display: none;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  a {\n    padding-left: 15px;\n    color: ", ";\n    text-decoration: none;\n    &:after {\n      content: '';\n      display: block;\n      height: 3px;\n      width: 0;\n      background: transparent;\n      transition: width 0.3s ease, background-color 0.3s ease;\n      margin: auto;\n    }\n    /* Change the width and background on hover, aka sliding out */\n    &:hover:after {\n      width: 100%;\n      background: black;\n    }\n  }\n  @media (max-width: 768px) {\n    display: none;\n  }\n"])), function (props) {
  return props.color || 'inherit';
});
var templateObject_1$9;

var NavLinks = function NavLinks(_a) {
  var children = _a.children,
      color = _a.color;
  return createElement(StyledNavLinks, {
    color: color
  }, children);
};

var StyledTopNavBar = styled.nav(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  width: ", ";\n  padding: 15px;\n  background-color: ", ";\n  @media (max-width: 768px) {\n    flex-direction: ", ";\n  }\n  align-items: center;\n  button {\n    margin-right: 15px;\n  }\n  img {\n    vertical-align: middle;\n  }\n"], ["\n  display: flex;\n  justify-content: space-between;\n  width: ", ";\n  padding: 15px;\n  background-color: ", ";\n  @media (max-width: 768px) {\n    flex-direction: ", ";\n  }\n  align-items: center;\n  button {\n    margin-right: 15px;\n  }\n  img {\n    vertical-align: middle;\n  }\n"])), function (props) {
  return props.contentWidth || 'unset';
}, function (props) {
  return props.backgroundColor || 'white';
}, function (props) {
  return props.flexDirection ? props.flexDirection : 'row';
});
var templateObject_1$a;

var TopNavBar = function TopNavBar(_a) {
  var action = _a.action,
      backgroundColor = _a.backgroundColor,
      buttonBackgroundColor = _a.buttonBackgroundColor,
      buttonColor = _a.buttonColor,
      buttonText = _a.buttonText,
      children = _a.children,
      color = _a.color,
      contentWidth = _a.contentWidth,
      flexDirection = _a.flexDirection,
      image = _a.image,
      imageHeight = _a.imageHeight,
      type = _a.type,
      width = _a.width;

  var _b = useState(false),
      isOpen = _b[0],
      setIsOpen = _b[1];

  var handleSetOpen = function handleSetOpen() {
    return setIsOpen(!isOpen);
  };

  return createElement(Fragment, null, createElement(MobileMenu, {
    isOpen: isOpen,
    setIsOpen: handleSetOpen,
    type: type,
    buttonText: buttonText,
    action: action
  }, children), createElement(WidthHelper, {
    backgroundColor: backgroundColor,
    width: width
  }, createElement(StyledTopNavBar, {
    flexDirection: flexDirection,
    backgroundColor: backgroundColor,
    contentWidth: contentWidth
  }, image && createElement("a", {
    href: "#"
  }, createElement("img", {
    src: image,
    alt: "brand logo",
    height: imageHeight ? imageHeight : '40px'
  })), createElement(NavLinks, {
    color: color
  }, children), buttonText && action && createElement(NavButton, {
    buttonText: buttonText,
    action: action,
    buttonColor: buttonColor,
    buttonBackgroundColor: buttonBackgroundColor
  }), createElement(BurgerHelper$1, null, createElement(Burger, {
    isOpen: isOpen,
    setIsOpen: handleSetOpen
  })))));
};

var BurgerHelper$1 = styled.div(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  @media (min-width: 768px) {\n    display: none;\n  }\n"], ["\n  @media (min-width: 768px) {\n    display: none;\n  }\n"])));
var WidthHelper = styled.div(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  background-color: ", ";\n  width: ", ";\n  display: flex;\n  justify-content: center;\n"], ["\n  background-color: ", ";\n  width: ", ";\n  display: flex;\n  justify-content: center;\n"])), function (props) {
  return props.backgroundColor || 'white';
}, function (props) {
  return props.width || 'unset';
});
var templateObject_1$b, templateObject_2$3;
var StyledFooter$1 = styled.div(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 100px;\n  font-size: 0.9em;\n  padding: 25px;\n  font-family: inherit;\n  color: ", ";\n  background-color: ", ";\n  p {\n    margin: 0 0 12px 0;\n  }\n  div,\n  a {\n    margin: 0 0 10px 0;\n    color: inherit;\n  }\n  a {\n    text-decoration: underline;\n    font-size: 0.9em;\n  }\n  h2 {\n    font-weight: 700;\n    font-size: 1em;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 100px;\n  font-size: 0.9em;\n  padding: 25px;\n  font-family: inherit;\n  color: ", ";\n  background-color: ", ";\n  p {\n    margin: 0 0 12px 0;\n  }\n  div,\n  a {\n    margin: 0 0 10px 0;\n    color: inherit;\n  }\n  a {\n    text-decoration: underline;\n    font-size: 0.9em;\n  }\n  h2 {\n    font-weight: 700;\n    font-size: 1em;\n  }\n"])), function (props) {
  return props.color || 'inherit';
}, function (props) {
  return props.backgroundColor || 'inherit';
});
var templateObject_1$c;

var Footer$1 = function Footer$1(_a) {
  var logo = _a.logo,
      logoWidth = _a.logoWidth,
      company = _a.company,
      vat = _a.vat,
      phone = _a.phone,
      contactTitle = _a.contactTitle,
      email = _a.email,
      address = _a.address,
      address2 = _a.address2,
      socialMediaTitle = _a.socialMediaTitle,
      facebook = _a.facebook,
      facebookHandle = _a.facebookHandle,
      facebookLogo = _a.facebookLogo,
      instagram = _a.instagram,
      instagramHandle = _a.instagramHandle,
      instagramLogo = _a.instagramLogo,
      linkedin = _a.linkedin,
      linkedinHandle = _a.linkedinHandle,
      linkedinLogo = _a.linkedinLogo,
      twitter = _a.twitter,
      twitterHandle = _a.twitterHandle,
      twitterLogo = _a.twitterLogo,
      youtube = _a.youtube,
      youtubeHandle = _a.youtubeHandle,
      youtubeLogo = _a.youtubeLogo,
      color = _a.color,
      backgroundColor = _a.backgroundColor,
      children = _a.children;
  return createElement(StyledFooter$1, {
    color: color,
    backgroundColor: backgroundColor
  }, createElement(Flex, {
    justifyContent: "space-between",
    flexWrap: "wrap"
  }, createElement(BrandWrapper$1, {
    p: 3
  }, logo && createElement(Logo$1, {
    src: logo,
    logoWidth: logoWidth,
    alt: "logo"
  }), company && createElement("p", null, company), vat && createElement("p", null, vat)), createElement(ContactWrapper$1, {
    p: 3
  }, contactTitle ? createElement("h2", null, contactTitle) : createElement("h2", null, "Contact"), phone && createElement(Styleda, {
    href: 'tel:' + phone
  }, phone), email && createElement(Styleda, {
    href: 'mailto:' + email
  }, email), address && createElement(Styleda, {
    href: 'https://maps.google.com/?q=' + address,
    target: "_blank",
    rel: "noreferrer noopener"
  }, address), address2 && createElement(Styleda, {
    href: 'https://maps.google.com/?q=' + address2,
    target: "_blank",
    rel: "noreferrer noopener"
  }, address2)), createElement(SocialMediaWrapper$1, {
    p: 3
  }, socialMediaTitle ? createElement("h2", null, socialMediaTitle) : createElement("h2", null, "Social media"), facebook && createElement(SocialMedium$1, null, facebookLogo && createElement(SocialMediaLogo$1, {
    src: facebookLogo,
    alt: "Facebook"
  }), createElement(Styleda, {
    href: facebook,
    rel: "noreferrer noopener",
    target: "_blank"
  }, facebookHandle ? facebookHandle : 'Facebook')), instagram && createElement(SocialMedium$1, null, instagramLogo && createElement(SocialMediaLogo$1, {
    src: instagramLogo,
    alt: "Instagram"
  }), createElement(Styleda, {
    className: "inline",
    href: instagram,
    rel: "noreferrer noopener",
    target: "_blank"
  }, instagramHandle ? instagramHandle : 'Instagram')), linkedin && createElement(SocialMedium$1, null, linkedinLogo && createElement(SocialMediaLogo$1, {
    src: linkedinLogo,
    alt: "LinkedIn"
  }), createElement(Styleda, {
    className: "inline",
    href: linkedin,
    rel: "noreferrer noopener",
    target: "_blank"
  }, linkedinHandle ? linkedinHandle : 'LinkedIn')), twitter && createElement(SocialMedium$1, null, twitterLogo && createElement(SocialMediaLogo$1, {
    src: twitterLogo,
    alt: "Twitter"
  }), createElement(Styleda, {
    className: "inline",
    href: twitter,
    rel: "noreferrer noopener",
    target: "_blank"
  }, twitterHandle ? twitterHandle : 'Twitter')), youtube && createElement(SocialMedium$1, null, youtubeLogo && createElement(SocialMediaLogo$1, {
    src: youtubeLogo,
    alt: "YouTube"
  }), createElement(Styleda, {
    className: "inline",
    href: linkedin,
    rel: "noreferrer noopener",
    target: "_blank"
  }, youtubeHandle ? youtubeHandle : 'YouTube'))), createElement(SiteMap$1, {
    p: 3
  }, createElement(Flex, {
    flexDirection: "column"
  }, children && createElement("h2", null, "Site map"), children))), createElement(Upshift$1, null, createElement(UpshiftContent$1, null, createElement("p", null, "Copyright \xA9 ", company), createElement("p", null, "Built with", ' ', createElement("span", {
    role: "img",
    "aria-label": "flexed biceps"
  }, "\uD83D\uDCAA"), ' ', "by", ' ', createElement(Styleda, {
    className: "inline",
    href: "https://upshift.be",
    rel: "noreferrer noopener",
    target: "_blank"
  }, "upshift")))));
};

var SocialMedium$1 = styled.div(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  margin: 10px 0;\n"], ["\n  margin: 10px 0;\n"])));
var SocialMediaLogo$1 = styled.img(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  width: 25px;\n  vertical-align: middle;\n  margin-right: 5px;\n"], ["\n  width: 25px;\n  vertical-align: middle;\n  margin-right: 5px;\n"])));
var Logo$1 = styled.img(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  width: ", ";\n  height: auto;\n  margin: 12px 0;\n"], ["\n  width: ", ";\n  height: auto;\n  margin: 12px 0;\n"])), function (props) {
  return props.logoWidth || '100px';
});
var BrandWrapper$1 = styled(Box)(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var Upshift$1 = styled.div(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"])));
var UpshiftContent$1 = styled.div(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var ContactWrapper$1 = styled(Box)(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject([""], [""])));
var SocialMediaWrapper$1 = styled(Box)(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var Styleda = styled.a(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject(["\n  font-size: inherit;\n  display: block;\n  &.inline {\n    display: inline;\n  }\n"], ["\n  font-size: inherit;\n  display: block;\n  &.inline {\n    display: inline;\n  }\n"])));
var SiteMap$1 = styled(Box)(templateObject_10 || (templateObject_10 = __makeTemplateObject([""], [""])));
var templateObject_1$d, templateObject_2$4, templateObject_3$1, templateObject_4$1, templateObject_5$1, templateObject_6$1, templateObject_7$1, templateObject_8$1, templateObject_9$1, templateObject_10;
var FormButton = styled.input(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n  border-radius: 4px;\n  border: none;\n  margin-left: auto;\n  display: flex;\n  color: white;\n  font-family: inherit;\n  font-size: 0.9em;\n  font-weight: 700;\n  outline: none;\n  padding: 15px 25px;\n  background-color: #21217d;\n  transition: all 0.23s ease-in-out;\n  &:hover {\n    box-shadow: 0 0 12px 0 #21217d;\n    cursor: pointer;\n    transition: all 0.23s ease-in-out;\n  }\n"], ["\n  border-radius: 4px;\n  border: none;\n  margin-left: auto;\n  display: flex;\n  color: white;\n  font-family: inherit;\n  font-size: 0.9em;\n  font-weight: 700;\n  outline: none;\n  padding: 15px 25px;\n  background-color: #21217d;\n  transition: all 0.23s ease-in-out;\n  &:hover {\n    box-shadow: 0 0 12px 0 #21217d;\n    cursor: pointer;\n    transition: all 0.23s ease-in-out;\n  }\n"])));
var templateObject_1$e;
var FormElement = styled.div(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n  padding: 10px 0;\n"], ["\n  padding: 10px 0;\n"])));
var templateObject_1$f;
var FormInput = styled.input(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n  border-radius: 4px;\n  border: 0px;\n  outline: none;\n  padding: 10px 15px;\n  &.fullWidth {\n    width: 100%;\n  }\n  &[type='checkbox'] {\n    margin-right: 10px;\n  }\n"], ["\n  border-radius: 4px;\n  border: 0px;\n  outline: none;\n  padding: 10px 15px;\n  &.fullWidth {\n    width: 100%;\n  }\n  &[type='checkbox'] {\n    margin-right: 10px;\n  }\n"])));
var templateObject_1$g;
var FormLabel = styled.label(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n  &.inline {\n    display: inline;\n  }\n  &.block {\n    display: block;\n  }\n"], ["\n  &.inline {\n    display: inline;\n  }\n  &.block {\n    display: block;\n  }\n"])));
var templateObject_1$h;
var FormTextArea = styled.textarea(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n  border-radius: 4px;\n  border: 0px;\n  display: block;\n  margin-bottom: 10px;\n  outline: none;\n  padding: 10px 15px;\n  resize: vertical;\n  width: 100%;\n"], ["\n  border-radius: 4px;\n  border: 0px;\n  display: block;\n  margin-bottom: 10px;\n  outline: none;\n  padding: 10px 15px;\n  resize: vertical;\n  width: 100%;\n"])));
var templateObject_1$i;
var FormWrapper = styled(Box)(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n  margin: auto;\n  max-width: 576px;\n  flex-grow: 1;\n"], ["\n  margin: auto;\n  max-width: 576px;\n  flex-grow: 1;\n"])));
var templateObject_1$j;
var BaseSvgWrapper = styled.span(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n  display: flex;\n  svg {\n    fill: none;\n    height: 34px;\n    stroke-width: 1px;\n    stroke: ", ";\n    width: 34px;\n  }\n"], ["\n  display: flex;\n  svg {\n    fill: none;\n    height: 34px;\n    stroke-width: 1px;\n    stroke: ", ";\n    width: 34px;\n  }\n"])), function (props) {
  return props.color ? props.color : "rgba(0, 0, 0, 0.85)";
});
var templateObject_1$k;
export { Burger, Footer as CookieBanner, CookieConsent, Footer$1 as Footer, FormButton, FormElement, FormInput, FormLabel, FormTextArea, FormWrapper, MobileMenu, NavButton, SideNavBar, BaseSvgWrapper as SvgWrapper, TopNavBar };